 

export const timerDelay = (delay: number, func?: () => void) => {
  const callIt = () => func?.()
  if (delay !== null) {
    const id = setTimeout(callIt, delay);
    return () => clearTimeout(id);
  }
}
  